import * as React from 'react';

import { addToCartSettings_Settings } from '../queries/__generated__/addToCartSettings';
import { BuyButton } from '../sharedComponents/BuyButton';

import {
  DescriptionWrapper,
  ContentWrapper,
  ModalButtonWrapper,
} from './styled';

interface IProductForProcessionalModalProps {
  description: JSX.Element | string;
  settings: addToCartSettings_Settings;
  productId: string;
  productCode: string;
  masterId: string | number;
}

export const SpecialAddToCartModal: React.FC<
  IProductForProcessionalModalProps
> = ({ description, settings, productId, productCode, masterId }) => {
  return (
    <ContentWrapper data-testid={'special-add-to-cart-modal'}>
      <DescriptionWrapper>{description}</DescriptionWrapper>
      <ModalButtonWrapper>
        <BuyButton
          productId={productId}
          productCode={productCode}
          isSpecialProduct={true}
          isOnSpecialModal={true}
          Settings={settings}
          buttonType="button"
          masterId={masterId}
        />
      </ModalButtonWrapper>
    </ContentWrapper>
  );
};
